import React, { FC } from 'react';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';
import { translations } from '../strings';
import { Loader } from 'lucide-react';
import animationStyles from '../../../sidebar/views/CreateTask/create_task/overlay/animation.module.css';
import styles from './index.module.css';
import cx from 'classnames';

type Props = {};

const PublicLoading: FC<Props> = () => {
  const { locale } = usePublicFeedbackState();
  const strings = translations(locale);

  return (
    <div className={styles.messageOuter}>
      <Loader className={cx(styles.loaderIcon, animationStyles.loaderIcon)} />
      <p className={styles.moreInfoMessage}>{strings.loading_message}</p>
    </div>
  );
};

export default PublicLoading;
